import { render } from "./Salon.vue?vue&type=template&id=62ce475c"
import script from "./Salon.vue?vue&type=script&lang=js"
export * from "./Salon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__